<template>
  <section class="p-4">
    <h2 class="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
      Reporte de ventas por cajero
    </h2>

    <div class="mb-4">
      <busqueda-en-fecha @seleccionada="onBusquedaEnFecha" />
    </div>

    <div
      v-if="noHayVentas"
      class="flex justify-center items-center min-h-[200px]"
    >
      <b-message type="is-info" has-icon>
        No hay datos disponibles. Selecciona un rango de fechas para ver los
        resultados.
      </b-message>
    </div>

    <b-table
      v-else
      :data="ventascajerofecha"
      :bordered="bordered"
      :striped="isStriped"
      :hoverable="true"
      :narrowed="false"
      :mobile-cards="true"
      class="rounded shadow border border-gray-200 dark:border-gray-700"
    >
      <b-table-column field="cajero" label="Cajero" v-slot="props">
        <span class="font-medium">{{ props.row.nombre }}</span>
      </b-table-column>

      <b-table-column field="totalEfectivo" label="Efectivo" v-slot="props">
        ${{ formatoMoneda(props.row.totalEfectivo) }}
      </b-table-column>

      <b-table-column field="totalNequi" label="Nequi" v-slot="props">
        ${{ formatoMoneda(props.row.totalNequi) }}
      </b-table-column>

      <b-table-column field="totalTarjeta" label="Tarjeta" v-slot="props">
        ${{ formatoMoneda(props.row.totalTarjeta) }}
      </b-table-column>

      <b-table-column
        field="totalTransferencia"
        label="Bancolombia"
        v-slot="props"
      >
        ${{ formatoMoneda(props.row.totalTransferencia) }}
      </b-table-column>

      <b-table-column
        field="pagocuentas"
        label="Pago Cuentas Liquidadas"
        v-slot="props"
      >
        ${{ formatoMoneda(props.row.pagocuentas) }}
      </b-table-column>

      <b-table-column field="devoluciones" label="Devoluciones" v-slot="props">
        ${{ formatoMoneda(props.row.devoluciones) }}
      </b-table-column>
    </b-table>
  </section>
</template>

<script>
// import MensajeInicial from '../Extras/MensajeInicial'
import HttpService from "../../Servicios/HttpService";
import BusquedaEnFecha from "../Extras/BusquedaEnFecha";

export default {
  name: "UsuariosComponent",
  components: { BusquedaEnFecha },

  data: () => ({
    bordered: true,
    isStriped: true,
    cargando: false,
    usuarios: [],
    ventascajerofecha: [],
    ventas: [],
    filtros: {
      fechaInicio: "",
      fechaFin: "",
    },
    fve: "",
  }),

  async mounted() {
    await this.obtenerDatos(); // Espera a obtener los datos antes de llamar a obtenerVentas

    this.obtenerVentas();
    document.title = "Cajeros";
  },

  methods: {
    formatoMoneda(valor) {
      const numero = parseInt(valor);
      return isNaN(numero) ? "0" : numero.toLocaleString("es-CO");
    },

    async obtenerDatos() {
      this.cargando = true;
      try {
        const resultado = await HttpService.obtenerConConsultas("ajustes.php", {
          accion: "obtener",
        });
        this.datosNegocio = resultado;
        this.fve = resultado.correo === 1 ? "si" : "no";
      } catch (error) {
        console.error("Error obteniendo datos:", error);
      } finally {
        this.cargando = false;
      }
    },
    onBusquedaEnFecha(fechas) {
      // Establecer la fecha de inicio con la hora constante a las 05:00:00 en UTC
      const fechaInicio = new Date(fechas[0]);
      fechaInicio.setUTCHours(5, 0, 0, 0); // Establecer la hora a las 05:00:00 en UTC
      // Formatear la fecha y hora como cadena "YYYY-MM-DD HH:mm:ss"
      const fechaInicioString =
        fechaInicio.toISOString().split("T")[0] + " 05:00:00";
      this.filtros.fechaInicio = fechaInicioString;
      // Establecer la fecha de fin con la hora constante a las 05:00:00 en UTC
      const fechaFin = new Date(fechas[1]);
      fechaFin.setUTCHours(5, 0, 0, 0); // Establecer la hora a las 05:00:00 en UTC
      // Sumar un día a la fecha fin
      fechaFin.setUTCDate(fechaFin.getUTCDate() + 1);
      // Formatear la fecha y hora como cadena "YYYY-MM-DD HH:mm:ss"
      const fechaFinString = fechaFin.toISOString().split("T")[0] + " 05:00:00";
      this.filtros.fechaFin = fechaFinString;
      this.fechaInicio = fechaInicioString;
      this.fechaFin = fechaFinString;
      this.obtenerVentas();
    },
    obtenerVentas() {
      this.cargando = true;
      let fechaInicio = new Date();
      fechaInicio.setHours(5, 0, 0, 0); // Inicio del día a las 5:00 AM

      let fechaFin = new Date(fechaInicio);
      fechaFin.setDate(fechaFin.getDate() + 1); // Día siguiente
      fechaFin.setHours(4, 49, 0, 0); // Fin a las 4:49 AM

      let filtrosVacios =
        !this.filtros ||
        Object.keys(this.filtros).length === 0 ||
        (!this.filtros.fechaInicio && !this.filtros.fechaFin);

      let payload = {
        filtros: filtrosVacios
          ? {
              fechaInicio:
                fechaInicio.toISOString().split("T")[0] + " 05:00:00",
              fechaFin: fechaFin.toISOString().split("T")[0] + " 04:49:00",
            }
          : this.filtros,
        accion: "obtener_ventas",
        fdv: this.fve,
      };
      HttpService.obtenerConConsultas("ventas_cajeros.php", payload).then(
        (resultado) => {
          this.ventascajerofecha = resultado.ventacajeros;
          console.log(this.ventas);
          this.ventas = resultado.ventas;
          this.cargando = false;
        }
      );
    },
  },
  computed: {
    noHayVentas() {
      const v = this.ventascajerofecha;

      // Validaciones por si llega mal
      if (!v || v === "0" || v === "o") return true;

      // Si es array vacío
      if (Array.isArray(v) && v.length === 0) return true;

      // Si solo trae "Totales" pero todo es null
      if (
        v.length === 1 &&
        v[0].nombre === "Totales" &&
        Object.values(v[0]).every((val, idx) =>
          idx === 0 ? true : val === null || val === 0
        )
      ) {
        return true;
      }

      return false;
    },
  },
};
</script>